<template>
  <div class="flex flex-col justify-center items-center">
    <div v-show="!hasChartData || !hasAnyInputs" class="w-full">
      <div    v-if="!hasAnyInputs"
              class="flex flex-row justify-around">
        <span class="text-center text-base text-gray-500">
          No threshold values have been set
        </span>
      </div>
      <div    v-else-if="hasChartData"
              class="w-full">
        <span class="text-center text-base text-gray-500">
          Creating Graph ... Please Wait
        </span>
      </div>
    </div>
    <div v-show="hasChartData"
         class="w-full h-48"
         :id="chartId">

    </div>
  </div>

</template>

<script>
import {amchartsMixin} from "@/mixins/amchartsMixin";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";

export default {
  name: "alarmProfilesGraph",
  mixins: [amchartsMixin],
  props: {
    high_alarm_value: null,
    high_alarm_time: null,
    high_alarm_instant: null,
    high_caution_value: null,
    high_caution_time: null,
    high_caution_instant: null,
    low_caution_value: null,
    low_caution_time: null,
    low_caution_instant: null,
    low_alarm_value: null,
    low_alarm_time: null,
    low_alarm_instant: null,
  },
  data(){
    return {
      data: {},
      loading: false,
      chartId: 'alarm-example',
      hasChartData: false,
      show: true,
    }
  },
  created() {
    this.chart = null
    this.chartData = []
    this.initializeAM5Charts();
    this.root = null;
  },
  mounted() {
    this.createData();
    this.makeChart();
  },
  methods: {
    createData(){
      let chartData = []
      // Let's just make some chartdata
      chartData.push({
        date: Date.now(),
        value: null,
        low_alarm: parseFloat(this.low_alarm_value),
        high_alarm: parseFloat(this.high_alarm_value),
        low_caution: parseFloat(this.low_caution_value),
        high_caution: parseFloat(this.high_caution_value),
      })
      chartData.push({
        date: Date.now() + 1000,
        value: null,
        low_alarm: parseFloat(this.low_alarm_value),
        high_alarm: parseFloat(this.high_alarm_value),
        low_caution: parseFloat(this.low_caution_value),
        high_caution: parseFloat(this.high_caution_value),
      })
      this.hasChartData = (chartData.length !== 0)
      this.chartData = chartData
    },
    makeChart() {
      if (this.chart != null) {
        this.chart.dispose();
      }

      if (this.root == null) {
        this.root = am5.Root.new(this.chartId);
      }

      if (this.chart == null) {
        this.chart = this.root.container.children.push(
          am5xy.XYChart.new(this.root, {
            panY: false,
            wheelY: "zoomX",
            layout: this.root.verticalLayout,
            height: am5.percent(100),
            paddingTop: 10,
            paddingBottom: 10,
          })
        );
      }

      let yAxis = this.chart.yAxes.push(
        am5xy.ValueAxis.new(this.root, {
          renderer: am5xy.AxisRendererY.new(this.root, {}),
        })
      );

      let xAxis = this.chart.xAxes.push(
        am5xy.DateAxis.new(this.root, {
          baseInterval: {timeUnit: "second", count: 1}, // When doing a date axis, you need to set the base interval
          renderer: am5xy.AxisRendererX.new(this.root, {}),
          visible: false
        })
      );
      xAxis.data.setAll(this.chartData);
      xAxis.get('renderer').grid.template.set('forceHidden', true); // This will hide the grid lines

      // AM5 examples will have an anonymous function but for our use we need to user an arrow function for 'this'.
      let createSeries = (name, field, settings) => {
        let series = this.chart.series.push(
          am5xy.LineSeries.new(this.root, {
            name: name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: field,
            valueXField: "date",
            stroke: settings.stroke,
          })
        );
        series.strokes.template.setAll({
          ...settings
        });
        series.data.setAll(this.chartData);
      }

      createSeries('High_alarm', 'high_alarm', {
        stroke: am5.color('#9b1b1b'),
        tensionX: 1,
        strokeWidth: 1
      });

      createSeries('High_caution', 'high_caution', {
        stroke: am5.color('#ffd300'),
        tensionX: 1,
        strokeWidth: 1
      });

      createSeries('Low_alarm', 'low_alarm', {
        stroke: am5.color('#9b1b1b'),
        tensionX: 1,
        strokeWidth: 1
      });

      createSeries('Low_caution', 'low_caution', {
        stroke: am5.color('#ffd300'),
        tensionX: 1,
        strokeWidth: 1
      });
    }
  },
  computed: {
    hasAnyInputs() {
      return this.high_alarm_value !== null ||
        this.high_caution_value !== null ||
        this.low_caution_value !== null ||
        this.low_alarm_value !== null;
    }
  },
  watch: {
    $props: {
      handler() {
        if (this.chart) {
          this.createData();
          let shouldRedraw = false;
          // We update the data on the chart object so we can use invalidateRawData
          let keys = [
            'low_alarm',
            'high_alarm',
            'low_caution',
            'high_caution',
          ];

          keys.forEach(key => {
            if (this.chartData[0][key] === '' || this.chartData[0][key] === null) {
              shouldRedraw = true;
            } else {
              this.chart.series.each((series) => {
                series.data.setAll(this.chartData);
              })
            }
          })

          if (shouldRedraw) {
            // Have to redraw if we lost a line or have a new line of data
            this.makeChart();
          }
        }
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>